import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";


const ACTIONS = [
  {
    id: "trade",
    label: "Trade Stocks",
    icon: "BarChart2",
    path: "/stock-exchange",
    color: "var(--color-primary)",
    description: "Live market",
  },
  {
    id: "portfolio",
    label: "Portfolio",
    icon: "PieChart",
    path: "/portfolio",
    color: "var(--color-success)",
    description: "View holdings",
  },
  {
    id: "business",
    label: "Businesses",
    icon: "Building2",
    path: "/businesses",
    color: "var(--color-accent)",
    description: "Manage empire",
  },
  {
    id: "crime",
    label: "Crime Hub",
    icon: "Skull",
    path: "/crime-hub",
    color: "var(--color-error)",
    description: "Underground ops",
  },
];

const QuickActions = () => {
  const navigate = useNavigate();

  return (
    <div
      className="rounded-xl border border-border p-4 md:p-5"
      style={{ background: "var(--color-card)" }}
    >
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Zap" size={15} color="var(--color-accent)" />
        <h3 className="font-heading text-sm font-semibold text-foreground">Quick Actions</h3>
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4">
        {ACTIONS?.map((action) => (
          <button
            key={action?.id}
            onClick={() => navigate(action?.path)}
            className="flex flex-col items-center gap-2 p-3 rounded-xl border border-border hover:border-primary/30 hover:bg-primary/5 transition-all duration-250 group cursor-pointer"
            style={{ background: "var(--color-secondary)" }}
          >
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-250 group-hover:scale-110"
              style={{ background: `${action?.color}15` }}
            >
              <Icon name={action?.icon} size={18} color={action?.color} />
            </div>
            <div className="text-center">
              <p className="font-heading text-xs font-semibold text-foreground leading-tight">
                {action?.label}
              </p>
              <p className="font-caption text-xs text-muted-foreground mt-0.5">
                {action?.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;